import { css } from '@emotion/react';
import { forwardRef } from 'react';

import { WeblogPageCategory, WeblogScreenName } from '../../../constants/weblog';
import DomainManager from '../../../utils/DomainManager';
import { logBrazeEvent } from '@myrealtrip/marketing-log';
import { helper } from '@myrealtrip/frontend-weblog';
import styled from '@emotion/styled';
import Icon from '../../../designSystem/components/Icon';
import { globalVariables } from '../../../designSystem/constants';
import { useEnvContext } from '../../../../modules/EnvProvider';

const { sendSearchLog } = helper;

const baseSearchLog = {
  eventName: 'gsearch',
  itemKind: 'search',
  screenName: WeblogScreenName.COMMON,
  pageCategory: WeblogPageCategory.COMMON,
};

interface Props {
  keyword: string;
  isSelected: boolean;
}

const RecentKeywordItem = forwardRef<HTMLAnchorElement, Props>(({ keyword, isSelected }, ref) => {
  const { targetEnv } = useEnvContext();
  const domainManager = new DomainManager(targetEnv);

  const targetUrl = `${domainManager.getTravelerServiceDomain()}/search-bridge?q=${encodeURIComponent(
    keyword
  )}`;

  const sendLog = () => {
    try {
      logBrazeEvent('search_offer', {
        search_offer: keyword,
      });

      sendSearchLog({
        ...baseSearchLog,
        searchWord: keyword,
        targetUrl,
      });
    } catch (e) {
      // ignore
    }
  };

  return (
    <Anchor href={targetUrl} ref={ref} isSelected={isSelected} onClick={sendLog}>
      <ClockIcon name="ic_clock_sm_filled_gray_500" alt="" />
      <Label>{keyword}</Label>
    </Anchor>
  );
});

RecentKeywordItem.displayName = 'RecentKeywordItem';

export default RecentKeywordItem;

const Anchor = styled.a<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: ${globalVariables.gray_50};
    `};

  :hover {
    background-color: ${globalVariables.gray_50}; /* gray-50 */
  }
`;

const ClockIcon = styled(Icon)`
  margin-right: 8px;
`;

const Label = styled.span`
  font-size: 15px;
  color: ${globalVariables.gray_700}; // gray-700
`;
